import { CancelOutlined } from "@mui/icons-material";
import { Alert } from "@mui/material";
import { useState } from "react";
import { useEffect } from "react";
import { useRef } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./TDMemberSearchForm.scss";
import { devLog } from "utils/devLog";
const searchTypeMap = new Map();

export default function TDMemberSearchForm(props) {
  const NAME = "NAME";
  const PHONE_NUMBER = "PHONE_NUMBER";
  const BANK_CARD_NUMBER = "BANK_CARD_NUMBER";

  const { t } = useTranslation();
  const formRef = useRef();
  const [firstName, setFirstName] = useState(props.currState.MemberLookup.firstName || props.currState.FirstName || "");
  const [lastName, setLastName] = useState(props.currState.MemberLookup.lastName || props.currState.LastName || "");
  const [postalCode, setPostalCode] = useState(
    props.currState.MemberLookup.postalCode || props.currState.postalCode || "",
  );
  const [phoneNumber, setPhoneNumber] = useState(
    props.currState.MemberLookup.phoneNumber || props.currState?.Number?.replace(/\D/g, "") || "",
  );
  const [bankCardNumber, setBankCardNumber] = useState(
    props.currState.MemberLookup.bankCardNumber || props.currState.bankCardNumber || "",
  );
  const [lessThan7, setLessThan7] = useState(false);

  const [searchTypes, setSearchTypes] = useState([
    { key: BANK_CARD_NUMBER, value: t("description.BankCardNumber") },
    { key: PHONE_NUMBER, value: t("description.ConfirmCustomerPhoneNumber") },
    { key: NAME, value: t("description.Name") },
  ]);

  const [selectedSearchType, setSelectedSearchType] = useState(
    props.currState.MemberLookup.searchType || BANK_CARD_NUMBER,
  );

  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setFirstName(firstName);
    setLastName(lastName);
    setPhoneNumber(phoneNumber);
    setPostalCode(postalCode);
    setBankCardNumber(bankCardNumber);
  }, [selectedSearchType]);

  useEffect(() => {
    if (typeof props.onFormUpdated === "function") {
      props.onFormUpdated({
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber,
        postalCode: postalCode,
        bankCardNumber: bankCardNumber,
        searchType: selectedSearchType,
      });
    }
  }, []);

  const onSubmit = (e) => {
    devLog("onSubmit", e);
    e.preventDefault();

    if (typeof props.onFormSubmit === "function") {
      props.onFormSubmit({
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber,
        postalCode: postalCode,
        bankCardNumber: bankCardNumber,
        searchType: selectedSearchType,
      });
    }
    return false;
  };

  const cardNumberLimit = (e) => {
    if (e.target.value.length > 4) {
      e.target.value = e.target.value.slice(0, -1);
    }
  };

  const windowWidth = () => {
    if (width < 720) {
      return "group-1 group-v2 input-v2";
    } else {
      return "group-1";
    }
  };

  const windowWidth2 = () => {
    if (width < 720) {
      return "label label-v2";
    } else {
      return "label";
    }
  };

  return (
    <>
      <div className="formContainer">
        <form ref={formRef} onSubmit={onSubmit} className="form">
          <Dropdown
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "10px",
            }}
          >
            <Dropdown.Toggle style={{ color: "white" }} variant="dark" id="dropdown-basic">
              {searchTypes.find((opt) => opt.key === selectedSearchType)?.value}
            </Dropdown.Toggle>
            <Dropdown.Menu variant="dark">
              {searchTypes.map((searchType) => {
                return (
                  <Dropdown.Item
                    active={searchType.key === selectedSearchType}
                    onClick={(e) => setSelectedSearchType(searchType.key)}
                  >
                    {searchType.value}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>

          {/*FIRST NAME*/}
          {selectedSearchType === NAME && (
            <>
              <div className={windowWidth()}>
                <div className={windowWidth2()}>{t("description.ConfirmCustomerFirstName")}:</div>
                <input
                  type="string"
                  placeholder="ex: JOHN"
                  name="firstName"
                  className="input form-control required"
                  value={firstName}
                  onChange={(e) => {
                    setFirstName(e.target.value?.trim()?.toUpperCase() || "");
                  }}
                  required={true}
                />
              </div>
            </>
          )}

          {/*LAST NAME*/}
          {selectedSearchType === NAME && (
            <>
              <div className={windowWidth()}>
                <div className={windowWidth2()}>{t("description.ConfirmCustomerLastName")}:</div>
                <input
                  type="string"
                  placeholder="ex: DOE"
                  name="lastName"
                  className="input form-control required "
                  value={lastName}
                  onChange={(e) => {
                    setLastName(e.target.value?.trim()?.toUpperCase() || "");
                  }}
                  required={true}
                />
              </div>
            </>
          )}

          {/*POSTAL CODE*/}
          {selectedSearchType === NAME && (
            <>
              <div className={windowWidth()}>
                <div className={windowWidth2()}>{t("description.ConfirmCustomerPostalCode")}:</div>
                <input
                  type="string"
                  placeholder="1A23B4"
                  name="postalCode"
                  className="input form-control required "
                  value={postalCode}
                  onChange={(e) => {
                    setPostalCode(e.target.value?.trim()?.toUpperCase() || "");
                  }}
                  required={true}
                />
              </div>
            </>
          )}

          {/*Bank Card Number*/}
          {selectedSearchType === BANK_CARD_NUMBER && (
            <>
              <div className={windowWidth()}>
                <div className={windowWidth2()}>{t("description.BankCardNumber")}:</div>
                <input
                  type="number"
                  placeholder={t("description.BankCardNumberLast4")}
                  name="bankCardNumber"
                  className="input form-control required"
                  value={bankCardNumber}
                  onChange={(e) => {
                    cardNumberLimit(e);
                    setBankCardNumber(e.target.value?.trim() || "");
                  }}
                  required={true}
                />
              </div>
            </>
          )}

          {/*LAST NAME*/}
          {selectedSearchType === BANK_CARD_NUMBER && (
            <>
              <div className={windowWidth()}>
                <div className={windowWidth2()}>{t("description.ConfirmCustomerLastName")}:</div>
                <input
                  type="string"
                  placeholder="ex: DOE"
                  name="lastName"
                  className="input form-control required"
                  value={lastName}
                  onChange={(e) => {
                    setLastName(e.target.value?.trim()?.toUpperCase() || "");
                  }}
                  required={true}
                />
              </div>
            </>
          )}

          {/*Phone*/}
          {selectedSearchType === PHONE_NUMBER && (
            <>
              <div className={windowWidth()}>
                <div className={windowWidth2()}>{t("description.ConfirmCustomerPhoneNumber")}:</div>
                <input
                  type="number"
                  placeholder="ex: 1234567890"
                  name="phoneNumber"
                  className="input form-control required"
                  value={phoneNumber}
                  onChange={(e) => {
                    setPhoneNumber(e.target.value?.trim() || "");
                  }}
                  required={true}
                />
              </div>
            </>
          )}

          <div className="footerContainer">
            <div>
              <button
                id="cancelButton"
                type="button"
                className="footer"
                style={{
                  background: "#f4f4f4",
                  color: "black",
                  paddingLeft: 14,
                }}
                onClick={(e) => {
                  e.preventDefault();
                  devLog("UI Cancel pressed");
                  if (typeof props.onUserCancel === "function") {
                    props.onUserCancel();
                  }
                }}
              >
                <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
                <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
              </button>
            </div>
            <button type="submit" className="ui-btn">
              {t("description.ConfirmCustomerSubmit")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
